(() => {
  if (window.__phSku3ModularInitialized) return;
  window.__phSku3ModularInitialized = true;

  const activateDetail = (trigger) => {
    const section = trigger.closest('[data-ph-detail-explorer]');
    if (!section) return;
    const selected = trigger.dataset.phDetailTrigger;
    const selectedDetail = section.querySelector(`.ph-lp-hero__detail[data-ph-detail-trigger="${selected}"]`);
    const shouldClose = trigger.classList.contains('ph-lp-hero__detail') && selectedDetail?.classList.contains('is-active');
    const activeKey = shouldClose ? null : selected;
    section.querySelectorAll('[data-ph-detail-trigger]').forEach((item) => {
      const active = item.dataset.phDetailTrigger === activeKey;
      item.classList.toggle('is-active', active);
      if (item.classList.contains('ph-lp-hero__detail')) item.setAttribute('aria-expanded', active ? 'true' : 'false');
      else item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    section.querySelectorAll('[data-ph-detail-panel]').forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.phDetailPanel === activeKey);
    });
    section.querySelectorAll('[data-ph-detail-body]').forEach((body) => {
      body.hidden = body.dataset.phDetailBody !== activeKey;
    });
  };

  document.addEventListener('click', (event) => {
    const detailTrigger = event.target.closest('[data-ph-detail-trigger]');
    if (detailTrigger) {
      activateDetail(detailTrigger);
      return;
    }

    const chamberTrigger = event.target.closest('[data-ph-chamber-trigger]');
    if (chamberTrigger) {
      const section = chamberTrigger.closest('[data-ph-chambers]');
      if (!section) return;
      const selected = chamberTrigger.dataset.phChamberTrigger;
      const panels = section.querySelectorAll('[data-ph-chamber-panel]');
      if (panels.length) {
        const targetPanel = section.querySelector(`[data-ph-chamber-panel="${selected}"]`);
        const shouldClose = targetPanel && !targetPanel.hidden;
        panels.forEach((panel) => { panel.hidden = shouldClose || panel.dataset.phChamberPanel !== selected; });
        section.querySelectorAll('.ph-lp-chamber-marker').forEach((marker) => {
          const active = !shouldClose && marker.dataset.phChamberTrigger === selected;
          marker.classList.toggle('is-active', active);
          marker.setAttribute('aria-expanded', active ? 'true' : 'false');
        });
        return;
      }
      const selectedItem = section.querySelector(`.ph-lp-chambers__list [data-ph-chamber-trigger="${selected}"]`)?.closest('li');
      const shouldClose = Boolean(chamberTrigger.closest('.ph-lp-chambers__list') && selectedItem?.classList.contains('is-active'));
      const activeKey = shouldClose ? null : selected;
      section.querySelectorAll('[data-ph-chamber-trigger]').forEach((item) => {
        const active = item.dataset.phChamberTrigger === activeKey;
        item.classList.toggle('is-active', active);
        if (item.closest('.ph-lp-chambers__list')) {
          item.setAttribute('aria-expanded', active ? 'true' : 'false');
          item.closest('li').classList.toggle('is-active', active);
        } else item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      return;
    }

    const chamberClose = event.target.closest('[data-ph-chamber-close]');
    if (chamberClose) {
      const section = chamberClose.closest('[data-ph-chambers]');
      if (!section) return;
      section.querySelectorAll('[data-ph-chamber-panel]').forEach((panel) => { panel.hidden = true; });
      section.querySelectorAll('.ph-lp-chamber-marker').forEach((marker) => { marker.classList.remove('is-active'); marker.setAttribute('aria-expanded', 'false'); });
      return;
    }

    const trigger = event.target.closest('[data-ph-sku3-buy]');
    if (!trigger) return;
    event.preventDefault();
    const purchase = document.querySelector('peterhanun-sku-3-purchase');
    if (purchase) purchase.scrollIntoView({ behavior: 'smooth', block: 'start' });
    else window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
